import React from 'react';
import { ClientId, ColumnConfig, FieldData } from '.';
import { Action } from '../dispatcher';
import classNames from 'classnames';

interface PropTypes {
  sectionId: ClientId;
  data: FieldData;
  dispatch: React.Dispatch<Action>;
  readOnly?: boolean;
  column: ColumnConfig;
  error?: string;
}

export function TextCol(props: PropTypes) {
  function handleTitleChange(title: string) {
    props.dispatch({
      type: 'field_data_change',
      sectionId: props.sectionId,
      fieldId: props.data.clientId,
      fieldData: { ...props.data, title },
    });
  }

  return (
    <div className={props.column.className}>
      <input
        className={classNames(
          'form-control',
          props.error && 'is-invalid',
          'fs-5',
        )}
        placeholder={props.column.placeholder ?? 'Insert field label'}
        value={props.data.title}
        onChange={(event) => handleTitleChange(event.target.value)}
        disabled={props.readOnly}
      />
      {props.error && (
        <div className='invalid-feedback d-block fs-6'>{props.error}</div>
      )}
    </div>
  );
}
